import { render, staticRenderFns } from "./InvoiceTags.vue?vue&type=template&id=319464e0&scoped=true"
import script from "./InvoiceTags.vue?vue&type=script&lang=js"
export * from "./InvoiceTags.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTags.vue?vue&type=style&index=0&id=319464e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319464e0",
  null
  
)

export default component.exports